import {
	AlertTriangle,
	CheckCircle2,
	ClipboardCheck,
	Eye,
	Users,
} from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'
import { CardButton } from '@/components/card-button'
import { PageHeader } from '@/components/commons'
import { hasRouteAccess } from '@/constants/permissions'
import { ROUTES } from '@/constants/routes'
import { useAuthStore } from '@/store'

export const InspectionsPage = () => {
	const navigate = useNavigate()
	const { t } = useTranslation()
	const userRole = useAuthStore((state) => state.user?.role)

	const inspectionTypes = [
		{
			id: 'directed',
			icon: <ClipboardCheck className="size-5 text-kaefer-ocean-blue" />,
			route: ROUTES.INSPECTIONS.DIRECTED.INDEX,
			iconBg: 'bg-kaefer-ocean-blue/10',
			borderColor: 'border-l-kaefer-ocean-blue',
		},
		{
			id: 'seeAndAct',
			icon: <Eye className="size-5 text-kaefer-grass-green" />,
			route: ROUTES.INSPECTIONS.SEE_AND_ACT.INDEX,
			iconBg: 'bg-kaefer-grass-green/10',
			borderColor: 'border-l-kaefer-grass-green',
			disabled: false,
		},
		{
			id: 'yellowCard',
			icon: <AlertTriangle className="size-5 text-kaefer-sunny-yellow" />,
			route: ROUTES.INSPECTIONS.YELLOW_CARD.INDEX,
			iconBg: 'bg-kaefer-sunny-yellow/10',
			borderColor: 'border-l-kaefer-sunny-yellow',
		},
		{
			id: 'interaction',
			icon: <Users className="size-5 text-kaefer-violet" />,
			route: ROUTES.INSPECTIONS.INTERACTION.INDEX,
			iconBg: 'bg-kaefer-violet/10',
			borderColor: 'border-l-kaefer-violet',
		},
		{
			id: 'actionsInProgress',
			icon: <CheckCircle2 className="size-5 text-kaefer-light-silver" />,
			route: ROUTES.INSPECTIONS.ACTIONS_IN_PROGRESS,
			iconBg: 'bg-kaefer-light-silver/10',
			borderColor: 'border-l-kaefer-light-silver',
			disabled: false,
		},
	]

	const handleBack = () => {
		navigate(ROUTES.DASHBOARD.HOME)
	}

	const visibleInspectionTypes = userRole
		? inspectionTypes.filter((type) => hasRouteAccess(userRole, type.route))
		: inspectionTypes

	return (
		<div className="px-4 py-6 sm:px-6">
			<PageHeader
				title={t('inspections.title')}
				description={t('inspections.subtitle')}
				onBack={handleBack}
			/>

			{/* Inspection Cards */}
			<div className="grid grid-cols-1 items-stretch gap-3 sm:grid-cols-2 lg:grid-cols-3">
				{visibleInspectionTypes.map((type) => (
					<CardButton
						key={type.id}
						icon={type.icon}
						iconBg={type.iconBg}
						borderColor={type.borderColor}
						title={t(`inspections.types.${type.id}.title`)}
						description={t(`inspections.types.${type.id}.description`)}
						disabled={type.disabled}
						onClick={() => (type.disabled ? undefined : navigate(type.route))}
					/>
				))}
			</div>
		</div>
	)
}
